module.exports = __webpack_public_path__ + "static/img/信息登记@3x.c7828d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/信息登记@3x.png
// module id = 309
// module chunks = 379 380